"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeClickAways = exports.ClickAway = void 0;
class ClickAway {
    constructor(element) {
        this.classesToRemove = [];
        this.element = element;
    }
    initialize() {
        this.setClassesToRemove(this.element);
        document.addEventListener('click', (event) => this.handleClick(event));
    }
    handleClick(event) {
        const boundingRect = this.element.getBoundingClientRect();
        if (!this.coordinatesAreOutsideBounds(boundingRect, event.clientX, event.clientY))
            return;
        if (this.targetIsOnOrWithinElement(this.element, event.target))
            return;
        this.removeClasses(this.element, this.classesToRemove);
    }
    removeClasses(element, classes) {
        classes.forEach(className => {
            element.classList.remove(className);
        });
    }
    setClassesToRemove(element) {
        const classesString = element.getAttribute(ClickAway.attributeName);
        if (classesString) {
            this.classesToRemove = classesString.split(',').map(s => s.trim());
        }
    }
    coordinatesAreOutsideBounds(bounds, x, y) {
        if (x < bounds.left)
            return true;
        if (x > bounds.right)
            return true;
        if (y < bounds.top)
            return true;
        if (y > bounds.bottom)
            return true;
        return false;
    }
    targetIsOnOrWithinElement(element, target) {
        if (target === element)
            return true;
        return element.contains(target);
    }
}
exports.ClickAway = ClickAway;
ClickAway.attributeName = 'data-js-click-away';
function initializeClickAways() {
    const elements = document.querySelectorAll(`[${ClickAway.attributeName}]`);
    elements.forEach(element => {
        const clickAway = new ClickAway(element);
        clickAway.initialize();
    });
}
exports.initializeClickAways = initializeClickAways;
